import ROUTES from '../routes';
import AccountingManagment from '../hoc/accounting-managment/accounting-managment';
import AccountingManagmentList from '../hoc/accounting-managment/list';
import CreateAccoutingJob from '../hoc/accounting-managment/create';
import EditAccoutingJob from '../hoc/accounting-managment/item';

const AccountingManagmentRoutes = {
  path: ROUTES.REPORTS_ACCOUNTING_MANAGMENT,
  element: <AccountingManagment />,
  children: [
    {
      path: ROUTES.REPORTS_ACCOUNTING_MANAGMENT_LIST,
      element: <AccountingManagmentList />,
      children: [
        {
          path: ROUTES.REPORTS_ACCOUNTING_MANAGMENT_CREATE,
          element: <CreateAccoutingJob />,
        },
        {
          path: ROUTES.REPORTS_ACCOUNTING_MANAGMENT_ITEM,
          element: <EditAccoutingJob />,
        },
      ],
    },
  ],
};

export default AccountingManagmentRoutes;
